<template>
	<v-card class="mt-5">
		<v-card-title class="primary py-1 custom-border-radius">
          <span class="white--text">Enhanced SQ Results</span>
        </v-card-title>

		<v-card-text class="px-3 pt-4 pb-1 custom-font-size">
			<p class="mb-1"><span class="font-weight-bold">LOC ID:</span> {{ locationID }}</p>
			<p class="mb-1"><span class="font-weight-bold">Serviceability Class:</span> {{ formattedSQResult.serviceabilityClass }}</p>
			<p class="mb-1"><span class="font-weight-bold">CSA ID:</span> {{ formattedSQResult.csaid }}</p>
		</v-card-text>
	</v-card>
</template>

<script>
	export default {
		name: "EnhancedSQ"
	}
</script>

<style lang="scss" scoped>
.custom-border-radius {
	border-radius: 0!important
}

.custom-font-size {
	font-size: 16px !important
}
</style>